import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CarBusinessLine } from 'src/app/public/car/constants/car-basic-data';
@Component({
    selector: 'app-rent-car-box-list',
    templateUrl: './rent-car-box-list.component.html',
    styleUrls: ['./rent-car-box-list.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RentCarBoxListComponent {

  businessLine: CarBusinessLine = CarBusinessLine.RENT; 

}
